import React from 'react'
import { Modal } from './Modal'
import { ReactComponent as TrevexLogo } from '../../assets/icons/TrevexLogo.svg'
import { ReactComponent as TrevexHalfLogo } from '../../assets/icons/TrevexHalfLogo.svg'
import { ReactComponent as Polygon } from '../../assets/icons/Polygon.svg'
import { Button } from './Button'
import { useNavigate } from 'react-router-dom'

function UserCheckPopUp({ showPopup, handleClosePopup }) {
  const navigate = useNavigate()
  return (
    showPopup && <Modal className='relative' modalHandle={handleClosePopup}>
      <div className='h-[25.5rem] w-[380px] text-secondarytwo'>
        <TrevexLogo />
        <TrevexHalfLogo className='absolute right-[-3px] top-[2.25rem]' />
        <div className='w-[303px] flex flex-col items-left text-left gap-4 w-[24rem] py-4'>
          <p className='text-[41px] font-semibold leading-[49.2px]'>Limited Offer! Join TREVEX Today!</p>
          <div>
            <div className='flex gap-2 items-center text-[15px] font-normal'>
              <p>Register today and receive an exclusive credit to download a company report for FREE! Gain the insights you need to assess partners and elevate your decision-making.</p>
            </div>
          </div>
          <Button
            onClick={() => {
              sessionStorage.setItem('popup_shown', JSON.stringify(true));
              handleClosePopup();
              navigate('/sign-up')
            }}
            classes="bg-primary px-4 py-2 text-white text-base rounded-0 w-full mt-2">Register Free Now!</Button>
        </div>
      </div>
    </Modal>
  )
}

export default UserCheckPopUp